var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"langBtn"},[_c('span',{on:{"click":_vm.handleLang}},[_vm._v(_vm._s(_vm.flag ? '切换中文' : 'lang English'))])])}
var staticRenderFns = []

export { render, staticRenderFns }